import { Button, Col, HeaderRow, LoaderOverlay, Modal, PaymentMethodListItem, Row } from "@emanprague/ppaskit";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import OnlinePaymentViewModel from "viewModels/finance/onlinePaymentViewModel";

const onlinePayment: ViewComponent<OnlinePaymentViewModel> = observer(({ vm }) => (
  <Modal centered show onHide={vm.requestClose} className="wider-modal">
    <Modal.Header closeButton>
      <HeaderRow id="modalTitle" title={vm.name} level={2} size="display-4" />
    </Modal.Header>
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <Modal.Body>
        <Row className="justify-content-center">
          <Col xs={12} sm={9}>
            {vm.paymentMethods && (
              <div role="radiogroup" aria-labelledby="modalTitle">
                {vm.paymentMethods.map(item => (
                  <PaymentMethodListItem
                    key={item.id}
                    className="mb-2"
                    label={item.name}
                    imgUrl={item.imageUrl}
                    selected={vm.isMethodSelected(item.id)}
                    name="payment-method"
                    value={item.id}
                    onChange={() => vm.handleMethodSelected(item.id)}
                  />
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button aria-describedby="modalTitle" disabled={!vm.canConfirm} onClick={vm.confirmGatewayMethod}>
          {vm.translateGeneral("continue_button")}
        </Button>
      </Modal.Footer>
    </LoaderOverlay>
  </Modal>
));

registerView(onlinePayment, OnlinePaymentViewModel);
